"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudyCommentCount = exports.StudyComment = void 0;
class StudyComment {
}
exports.StudyComment = StudyComment;
class StudyCommentCount {
}
exports.StudyCommentCount = StudyCommentCount;
//# sourceMappingURL=studyComment.js.map